import { render, staticRenderFns } from "./checkVersion.vue?vue&type=template&id=14908e7a&"
import script from "./checkVersion.vue?vue&type=script&lang=js&"
export * from "./checkVersion.vue?vue&type=script&lang=js&"
import style0 from "./checkVersion.vue?vue&type=style&index=0&id=14908e7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports